module.exports = __webpack_public_path__ + "static/media/facebook-line.4958c611.svg";